export default __webpack_public_path__ + "static/media/folder_blue_icon.50c1eb78.svg";